import { formatDatePast } from '@spotify/confidence-core-react';
import { PlanningDataFragment } from '@spotify/confidence-graphql';

import { usePlanningDates } from '../../hooks';

type PlanningUnderlineTextProps = {
  planning?: PlanningDataFragment | null;
};

export const PlanningUnderlineText = ({
  planning,
}: PlanningUnderlineTextProps) => {
  const { actualStartDate, actualEndDate } = usePlanningDates(planning);

  if (actualEndDate) {
    return `Ended ${formatDatePast(actualEndDate)}`;
  }

  if (actualStartDate) {
    return `Launched ${formatDatePast(actualStartDate)}`;
  }

  return null;
};
